import { render, staticRenderFns } from "./image-card.vue?vue&type=template&id=78749c2b"
import script from "./image-card.vue?vue&type=script&lang=ts"
export * from "./image-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChefImageSlider: require('/vercel/path0/components/chef/image-slider.vue').default})
